import { columnsEquivalencySimulation } from "../../../../types/columnsTables/columnEquivalencySimulator";

export const useColumnsEquivalencySimulator = (dispatch) => {
    const { columns, props } = columnsEquivalencySimulation(undefined, undefined);
    return { columns, props };
};
